export default {
    userIcon:'https://financial-search.oss-cn-beijing.aliyuncs.com/web-resource/common/user-icon.png',
    defaultCover:'https://financial-search.oss-cn-beijing.aliyuncs.com/rtc/share-cover.png',
}